// import React from 'react';
// import HlcFooter from '../components/HlcFooter';
// import Navbar from '../components/Navbar';

// const IndustrialPage = () => {
//     const navigate = useNavigate();

//       const handleSubcategoryClick = (subType) => {
//     navigate('/product-by-application', {
//       state: {
//         category: 'Industrial Lighting',
//         subcategory: subType,
//         subcategoryDescription: `Explore the best ${subType} lighting products for industrial spaces.`,
//       },
//     });
//   };
//   return (
//     <>
//     <Navbar/>
//       {/* ========== SECTION: INDUSTRIAL SPACES GRID (HLC) ========== */}
//       <section style={{marginTop:100}} className="hlc-solGrid" id="industrial-spaces" aria-label="Industrial Lighting Spaces">
//         <div className="hlc-solGrid__inner">
//           <header className="hlc-solGrid__head">
//             <p className="hlc-solGrid__eyebrow">INDUSTRIAL SPACES</p>
//             <h2 className="hlc-solGrid__title">Industrial Lighting</h2>
//             <p className="hlc-solGrid__sub">
//               High-output, durable lighting solutions for factories, warehouses and demanding industrial environments.
//             </p>
//           </header>

//           <div className="hlc-solGrid__row">
//             {/* FACTORIES */}
//             <a 
//               className="hlc-sCard" 
//               href="https://skyblue-mink-835304.hostingersite.com/shop/" 
//               aria-label="Factories Lighting"
//             >
//               <div className="hlc-sCard__imgwrap">
//                 <img 
//                   decoding="async" 
//                   src="https://skyblue-mink-835304.hostingersite.com/wp-content/uploads/2025/12/Factories-Lighting.png" 
//                   alt="Factories Lighting"
//                 />
//                 <span className="hlc-sCard__tag">FACTORIES</span>
//               </div>
//               <div className="hlc-sCard__body">
//                 <h3 className="hlc-sCard__title">Factories Lighting</h3>
//                 <p className="hlc-sCard__text">High-lumen, rugged fixtures for production floors and heavy-duty operations.</p>
//                 <ul className="hlc-sCard__bullets">
//                   <li>High lumen output</li>
//                   <li>Heat &amp; dust resistant</li>
//                   <li>Uniform illumination</li>
//                 </ul>
//                 <span className="hlc-sCard__cta">EXPLORE FACTORIES →</span>
//               </div>
//             </a>

//             {/* WAREHOUSES */}
//             <a 
//               className="hlc-sCard" 
//               href="https://skyblue-mink-835304.hostingersite.com/shop/" 
//               aria-label="Warehouse Lighting"
//             >
//               <div className="hlc-sCard__imgwrap">
//                 <img 
//                   decoding="async" 
//                   src="https://skyblue-mink-835304.hostingersite.com/wp-content/uploads/2025/12/Warehouse-Lighting.png" 
//                   alt="Warehouse Lighting"
//                 />
//                 <span className="hlc-sCard__tag">WAREHOUSES</span>
//               </div>
//               <div className="hlc-sCard__body">
//                 <h3 className="hlc-sCard__title">Warehouse Lighting</h3>
//                 <p className="hlc-sCard__text">Bright, wide-coverage lighting to improve visibility across aisles &amp; storage zones.</p>
//                 <ul className="hlc-sCard__bullets">
//                   <li>Wide coverage</li>
//                   <li>Low maintenance</li>
//                   <li>Energy saving LEDs</li>
//                 </ul>
//                 <span className="hlc-sCard__cta">EXPLORE WAREHOUSES →</span>
//               </div>
//             </a>

//             {/* WORKSHOPS */}
//             <a 
//               className="hlc-sCard" 
//               href="https://skyblue-mink-835304.hostingersite.com/shop/" 
//               aria-label="Workshops Lighting"
//             >
//               <div className="hlc-sCard__imgwrap">
//                 <img 
//                   decoding="async" 
//                   src="https://skyblue-mink-835304.hostingersite.com/wp-content/uploads/2025/12/Workshops-Lighting.png" 
//                   alt="Workshops Lighting"
//                 />
//                 <span className="hlc-sCard__tag">WORKSHOPS</span>
//               </div>
//               <div className="hlc-sCard__body">
//                 <h3 className="hlc-sCard__title">Workshops Lighting</h3>
//                 <p className="hlc-sCard__text">Task-focused illumination for assembly, repair and precision work areas.</p>
//                 <ul className="hlc-sCard__bullets">
//                   <li>Clear task lighting</li>
//                   <li>Reduced shadows</li>
//                   <li>Comfortable visibility</li>
//                 </ul>
//                 <span className="hlc-sCard__cta">EXPLORE WORKSHOPS →</span>
//               </div>
//             </a>
//           </div>
//         </div>
//       </section>

//       {/* ================= RESIDENTIAL LIGHTING HERO ================= */}
//       <section className="hlc-res-hero">
//         <div className="hlc-res-hero__inner">
//           <div className="hlc-res-hero__cta">
//             <a 
//               href="https://skyblue-mink-835304.hostingersite.com/shop/" 
//               className="btn-primary"
//             >
//               Explore Products
//             </a>
//             <a 
//               href="https://wa.me/923337244858" 
//               target="_blank" 
//               rel="noopener noreferrer"
//               className="btn-secondary"
//             >
//               WhatsApp Expert
//             </a>
//           </div>
//         </div>
//       </section>

//       <style jsx>{`
//         :root {
//           --hlc-magenta: #9b1f6c;
//           --hlc-plum: #542757;
//           --hlc-navy: #35335b;
//           --hlc-ink: #141320;
//           --hlc-muted: #6f6d83;
//           --hlc-line: #eceaf1;
//         }

//         /* SECTION WRAP */
//         .hlc-solGrid {
//           width: 100vw;
//           max-width: 100vw;
//           position: relative;
//           left: 50%;
//           margin-left: -50vw;
//           padding: clamp(34px, 6vw, 54px) 0;
//           background: linear-gradient(180deg, #f7f7fb 0%, #ffffff 100%);
//           font-family: "Open Sans", system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;
//           color: var(--hlc-ink);
//         }

//         .hlc-solGrid__inner {
//           width: min(1200px, 92vw);
//           margin: 0 auto;
//         }

//         /* HEAD */
//         .hlc-solGrid__head {
//           text-align: center;
//           margin-bottom: clamp(18px, 3vw, 28px);
//         }

//         .hlc-solGrid__eyebrow {
//           margin: 0 0 6px;
//           font-size: 11px;
//           letter-spacing: 0.18em;
//           text-transform: uppercase;
//           color: var(--hlc-muted);
//         }

//         .hlc-solGrid__title {
//           margin: 0 0 8px;
//           font-size: clamp(22px, 3vw, 32px);
//           font-weight: 800;
//           letter-spacing: -0.02em;
//           color: var(--hlc-navy);
//         }

//         .hlc-solGrid__sub {
//           margin: 0 auto;
//           max-width: 720px;
//           font-size: 14px;
//           line-height: 1.55;
//           color: #4d4b60;
//         }

//         /* GRID */
//         .hlc-solGrid__row {
//           margin-top: clamp(18px, 3vw, 26px);
//           display: grid;
//           grid-template-columns: repeat(3, minmax(0, 1fr));
//           gap: clamp(14px, 2vw, 18px);
//         }

//         /* CARD */
//         .hlc-sCard {
//           display: flex;
//           flex-direction: column;
//           text-decoration: none;
//           background: #fff;
//           border: 1px solid var(--hlc-line);
//           box-shadow: 0 10px 24px rgba(20, 19, 32, 0.06);
//           overflow: hidden;
//           color: var(--hlc-ink);
//           transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
//         }

//         .hlc-sCard:hover {
//           border-color: rgba(155, 31, 108, 0.35);
//           box-shadow: 0 18px 40px rgba(155, 31, 108, 0.18);
//           transform: translateY(-4px);
//         }

//         .hlc-sCard__imgwrap {
//           position: relative;
//           aspect-ratio: 4/3;
//           overflow: hidden;
//           background: #f6f6f6;
//         }

//         .hlc-sCard__imgwrap img {
//           position: absolute;
//           inset: 0;
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//           transform: scale(1.02);
//           transition: transform 0.4s ease;
//         }

//         .hlc-sCard:hover .hlc-sCard__imgwrap img {
//           transform: scale(1.06);
//         }

//         /* TAG */
//         .hlc-sCard__tag {
//           position: absolute;
//           top: 12px;
//           left: 12px;
//           padding: 6px 10px;
//           background: rgba(20, 19, 32, 0.72);
//           color: #fff;
//           font-size: 12px;
//           font-weight: 800;
//           letter-spacing: 0.12em;
//           text-transform: uppercase;
//           border-radius: 0;
//           backdrop-filter: blur(3px);
//         }

//         /* BODY */
//         .hlc-sCard__body {
//           padding: 14px 14px 16px;
//         }

//         .hlc-sCard__title {
//           margin: 0 0 6px;
//           font-size: 18px;
//           font-weight: 800;
//           color: var(--hlc-navy);
//           letter-spacing: -0.01em;
//         }

//         .hlc-sCard__text {
//           margin: 0 0 10px;
//           font-size: 13.5px;
//           color: #55536a;
//           line-height: 1.55;
//         }

//         .hlc-sCard__bullets {
//           margin: 0 0 12px;
//           padding-left: 18px;
//           color: #5d5b73;
//         }

//         .hlc-sCard__bullets li {
//           margin: 0 0 6px;
//           font-size: 13px;
//         }

//         .hlc-sCard__cta {
//           display: inline-block;
//           font-size: 12px;
//           font-weight: 800;
//           letter-spacing: 0.12em;
//           text-transform: uppercase;
//           color: var(--hlc-magenta);
//         }

//         .hlc-sCard:hover .hlc-sCard__cta {
//           color: var(--hlc-plum);
//         }

//         /* RESPONSIVE */
//         @media (max-width: 992px) {
//           .hlc-solGrid__row {
//             grid-template-columns: repeat(2, minmax(0, 1fr));
//           }
//         }

//         @media (max-width: 600px) {
//           .hlc-solGrid {
//             padding: 26px 0 34px;
//           }

//           .hlc-solGrid__row {
//             grid-template-columns: 1fr;
//           }

//           .hlc-sCard__body {
//             padding: 12px;
//           }
//         }

//         /* ================= RESIDENTIAL HERO ================= */
//         .hlc-res-hero__inner {
//           display: flex;
//           justify-content: center;
//           align-items: center;
//         }

//         /* CTA */
//         .hlc-res-hero__cta {
//           display: flex;
//           gap: 14px;
//           flex-wrap: wrap;
//           justify-content: center;
//           align-items: center;
//           text-align: center;
//         }

//         /* Buttons */
//         .btn-primary,
//         .btn-secondary {
//           padding: 12px 22px;
//           font-weight: 800;
//           font-size: 14px;
//           text-decoration: none;
//           border-radius: 0;
//           border: 2px solid transparent;
//         }

//         /* Primary */
//         .btn-primary {
//           background: #9b1f6c;
//           color: #fff;
//           border-color: #9b1f6c;
//         }

//         .btn-primary:hover {
//           background: #7f1958;
//           border-color: #7f1958;
//         }

//         /* Secondary */
//         .btn-secondary {
//           background: #fff;
//           color: #9b1f6c;
//           border-color: #9b1f6c;
//         }

//         .btn-secondary:hover {
//           background: #9b1f6c;
//           color: #fff;
//         }

//         /* RESPONSIVE */
//         @media (max-width: 768px) {
//           .hlc-res-hero {
//             padding: 40px 16px 50px;
//           }
//         }
//       `}</style>
//             <div style={{height:50}}/>
// <HlcFooter  />
//     </>
//   );
// };

// export default IndustrialPage;



import React from 'react';
import { useNavigate } from 'react-router-dom';
import HlcFooter from '../components/HlcFooter';
import Navbar from '../components/Navbar';
import IndustrialImg from '../assets/indoor/hlc-industrial-lighting.webp';

const IndustrialPage = () => {
  const navigate = useNavigate();

  const handleSubcategoryClick = (subType) => {
    navigate('/product-by-application', {
      state: {
        category: 'Industrial Lighting',
        subcategory: subType,
        subcategoryDescription: `Explore the best ${subType} lighting products for industrial spaces.`,
      },
    });
  };

  return (
    <>
      <Navbar />

      {/* ========== SECTION: INDUSTRIAL SPACES GRID (HLC) ========== */}
      <section
        style={{ marginTop: 100 }}
        className="hlc-solGrid"
        id="industrial-spaces"
        aria-label="Industrial Lighting Spaces"
      >
        <div className="hlc-solGrid__inner">
          <header className="hlc-solGrid__head">
            <p className="hlc-solGrid__eyebrow">INDUSTRIAL SPACES</p>
            <h2 className="hlc-solGrid__title">Industrial Lighting</h2>
            <p className="hlc-solGrid__sub">
              High-output, durable lighting solutions for factories, warehouses and demanding industrial environments.
            </p>
          </header>

          <div className="hlc-solGrid__row">
            {/* FACTORIES */}
            <div
              className="hlc-sCard"
              role="button"
              onClick={() => handleSubcategoryClick('Factories Lighting')}
            >
              <div className="hlc-sCard__imgwrap">
                <img
                  decoding="async"
                  src={IndustrialImg}
                  alt="Factories Lighting"
                />
                <span className="hlc-sCard__tag">FACTORIES</span>
              </div>
              <div className="hlc-sCard__body">
                <h3 className="hlc-sCard__title">Factories Lighting</h3>
                <p className="hlc-sCard__text">
                  High-lumen, rugged fixtures for production floors and heavy-duty operations.
                </p>
                <ul className="hlc-sCard__bullets">
                  <li>• High lumen output</li>
                  <li>• Heat &amp; dust resistant</li>
                  <li>• Uniform illumination</li>
                </ul>
                <span className="hlc-sCard__cta">EXPLORE FACTORIES →</span>
              </div>
            </div>

            {/* WAREHOUSES */}
            <div
              className="hlc-sCard"
              role="button"
              onClick={() => handleSubcategoryClick('Warehouse Lighting')}
            >
              <div className="hlc-sCard__imgwrap">
                <img
                  decoding="async"
                  src={IndustrialImg}
                  alt="Warehouse Lighting"
                />
                <span className="hlc-sCard__tag">WAREHOUSES</span>
              </div>
              <div className="hlc-sCard__body">
                <h3 className="hlc-sCard__title">Warehouse Lighting</h3>
                <p className="hlc-sCard__text">
                  Bright, wide-coverage lighting to improve visibility across aisles &amp; storage zones.
                </p>
                <ul className="hlc-sCard__bullets">
                  <li>• Wide coverage</li>
                  <li>• Low maintenance</li>
                  <li>• Energy saving LEDs</li>
                </ul>
                <span className="hlc-sCard__cta">EXPLORE WAREHOUSES →</span>
              </div>
            </div>

            {/* WORKSHOPS */}
            <div
              className="hlc-sCard"
              role="button"
              onClick={() => handleSubcategoryClick('Workshops Lighting')}
            >
              <div className="hlc-sCard__imgwrap">
                <img
                  decoding="async"
                  src={IndustrialImg}
                  alt="Workshops Lighting"
                />
                <span className="hlc-sCard__tag">WORKSHOPS</span>
              </div>
              <div className="hlc-sCard__body">
                <h3 className="hlc-sCard__title">Workshops Lighting</h3>
                <p className="hlc-sCard__text">
                  Task-focused illumination for assembly, repair and precision work areas.
                </p>
                <ul className="hlc-sCard__bullets">
                  <li>• Clear task lighting</li>
                  <li>• Reduced shadows</li>
                  <li>• Comfortable visibility</li>
                </ul>
                <span className="hlc-sCard__cta">EXPLORE WORKSHOPS →</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= HERO CTA ================= */}
      <section className="hlc-res-hero">
        <div className="hlc-res-hero__inner">
          <div className="hlc-res-hero__cta">
            <button
              className="btn-primary"
              onClick={()=>navigate('/shop')}
            >
              Explore Products
            </button>

            <a
              href="https://wa.me/923337244858"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-secondary"
            >
              WhatsApp Expert
            </a>
          </div>
        </div>
      </section>

      {/* ================= STYLES (UNCHANGED) ================= */}
     <style jsx>{`
        :root {
          --hlc-magenta: #9b1f6c;
          --hlc-plum: #542757;
          --hlc-navy: #35335b;
          --hlc-ink: #141320;
          --hlc-muted: #6f6d83;
          --hlc-line: #eceaf1;
        }

        /* SECTION WRAP */
        .hlc-solGrid {
          width: 100vw;
          max-width: 100vw;
          position: relative;
          left: 50%;
          margin-left: -50vw;
          padding: clamp(34px, 6vw, 54px) 0;
          background: linear-gradient(180deg, #f7f7fb 0%, #ffffff 100%);
          font-family: "Open Sans", system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;
          color: var(--hlc-ink);
        }

        .hlc-solGrid__inner {
          width: min(1200px, 92vw);
          margin: 0 auto;
        }

        /* HEAD */
        .hlc-solGrid__head {
          text-align: center;
          margin-bottom: clamp(18px, 3vw, 28px);
        }

        .hlc-solGrid__eyebrow {
          margin: 0 0 6px;
          font-size: 11px;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          color: var(--hlc-muted);
        }

        .hlc-solGrid__title {
          margin: 0 0 8px;
          font-size: clamp(22px, 3vw, 32px);
          font-weight: 800;
          letter-spacing: -0.02em;
          color: var(--hlc-navy);
        }

        .hlc-solGrid__sub {
          margin: 0 auto;
          max-width: 720px;
          font-size: 14px;
          line-height: 1.55;
          color: #4d4b60;
        }

        /* GRID */
        .hlc-solGrid__row {
          margin-top: clamp(18px, 3vw, 26px);
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: clamp(14px, 2vw, 18px);
        }

        /* CARD */
        .hlc-sCard {
          display: flex;
          flex-direction: column;
          text-decoration: none;
          background: #fff;
          border: 1px solid var(--hlc-line);
          box-shadow: 0 10px 24px rgba(20, 19, 32, 0.06);
          overflow: hidden;
          color: var(--hlc-ink);
          transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
        }

        .hlc-sCard:hover {
          border-color: rgba(155, 31, 108, 0.35);
          box-shadow: 0 18px 40px rgba(155, 31, 108, 0.18);
          transform: translateY(-4px);
        }

        .hlc-sCard__imgwrap {
          position: relative;
          aspect-ratio: 4/3;
          overflow: hidden;
          background: #f6f6f6;
        }

        .hlc-sCard__imgwrap img {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          transform: scale(1.02);
          transition: transform 0.4s ease;
        }

        .hlc-sCard:hover .hlc-sCard__imgwrap img {
          transform: scale(1.06);
        }

        /* TAG */
        .hlc-sCard__tag {
          position: absolute;
          top: 12px;
          left: 12px;
          padding: 6px 10px;
          background: rgba(20, 19, 32, 0.72);
          color: #fff;
          font-size: 12px;
          font-weight: 800;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          border-radius: 0;
          backdrop-filter: blur(3px);
        }

        /* BODY */
        .hlc-sCard__body {
          padding: 14px 14px 16px;
        }

        .hlc-sCard__title {
          margin: 0 0 6px;
          font-size: 18px;
          font-weight: 800;
          color: var(--hlc-navy);
          letter-spacing: -0.01em;
        }

        .hlc-sCard__text {
          margin: 0 0 10px;
          font-size: 13.5px;
          color: #55536a;
          line-height: 1.55;
        }

        .hlc-sCard__bullets {
          margin: 0 0 12px;
          padding-left: 18px;
          color: #5d5b73;
        }

        .hlc-sCard__bullets li {
          margin: 0 0 6px;
          font-size: 13px;
        }

        .hlc-sCard__cta {
          display: inline-block;
          font-size: 12px;
          font-weight: 800;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          color: var(--hlc-magenta);
        }

        .hlc-sCard:hover .hlc-sCard__cta {
          color: var(--hlc-plum);
        }

        /* RESPONSIVE */
        @media (max-width: 992px) {
          .hlc-solGrid__row {
            grid-template-columns: repeat(2, minmax(0, 1fr));
          }
        }

        @media (max-width: 600px) {
          .hlc-solGrid {
            padding: 26px 0 34px;
          }

          .hlc-solGrid__row {
            grid-template-columns: 1fr;
          }

          .hlc-sCard__body {
            padding: 12px;
          }
        }

        /* ================= RESIDENTIAL HERO ================= */
        .hlc-res-hero__inner {
          display: flex;
          justify-content: center;
          align-items: center;
        }

        /* CTA */
        .hlc-res-hero__cta {
          display: flex;
          gap: 14px;
          flex-wrap: wrap;
          justify-content: center;
          align-items: center;
          text-align: center;
        }

        /* Buttons */
        .btn-primary,
        .btn-secondary {
          padding: 12px 22px;
          font-weight: 800;
          font-size: 14px;
          text-decoration: none;
          border-radius: 0;
          border: 2px solid transparent;
        }

        /* Primary */
        .btn-primary {
          background: #9b1f6c;
          color: #fff;
          border-color: #9b1f6c;
        }

        .btn-primary:hover {
          background: #7f1958;
          border-color: #7f1958;
        }

        /* Secondary */
        .btn-secondary {
          background: #fff;
          color: #9b1f6c;
          border-color: #9b1f6c;
        }

        .btn-secondary:hover {
          background: #9b1f6c;
          color: #fff;
        }

        /* RESPONSIVE */
        @media (max-width: 768px) {
          .hlc-res-hero {
            padding: 40px 16px 50px;
          }
        }
      `}</style>

      <div style={{ height: 50 }} />
      <HlcFooter />
    </>
  );
};

export default IndustrialPage;
